let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iXNpN")).then(() => parcelRequire('4xObW'));